import { LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { Program } from '@models/membership/Program'
import { useAppSelector } from '@store/hooks'
import { selectProgramById } from '@store/membership/ProgramReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<Program> & {}

const ProgramPasscodeTag: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectProgramById(id!))

  if (!item) {
    return <></>
  }

  return (
    <>
      {item.passcode ? (
        <Tag icon={<LockOutlined />} color="orange">
          Password protected
        </Tag>
      ) : (
        <Tag icon={<UnlockOutlined />} color="green">
          Public
        </Tag>
      )}
    </>
  )
}

type ProgramPasscodeTagType = { PasscodeTag: typeof ProgramPasscodeTag }

export { ProgramPasscodeTag, type ProgramPasscodeTagType }
